import {
    initKeyboardShortcutHandler,
    addKeyboardShortcuts,
    removeKeyboardShortcuts,
} from './keyboard-handler';

export { initKeyboardShortcutHandler, addKeyboardShortcuts, removeKeyboardShortcuts };
